<template>
    <div>
        <!-- detalhes da oferta -->
        <div class="ec-listagem mb-4">
            <div class="ec-listagem__toolbar">
                <span class="font-weight-bold"><b-icon icon="journal-text"></b-icon> Detalhes da oferta</span>
            </div>
            <div class="table-responsive ec-listagem__rolagem">
                <table class="table table-sm ec-tabela mb-0">
                    <thead class="ec-thead">
                        <tr>
                            <th class="text-left">Oferta</th>
                            <th>Ano</th>
                            <th>Cód. oferta CRM</th>
                            <th>Cód. oferta ERP</th>
                            <th>Início das inscrições</th>
                            <th>Término das inscrições</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-left" data-label="Oferta">
                                <span class="ec-tabela__principal">{{ oferta.descricaoturma }}</span>
                            </td>
                            <td data-label="Ano">{{ oferta.anoinicio }}</td>
                            <td data-label="Cód. oferta CRM">{{ (oferta.codigooferta ? oferta.codigooferta : oferta.codigoofertapse) }}</td>
                            <td data-label="Cód. oferta ERP">{{ oferta.codigoturma }}</td>
                            <td data-label="Início das inscrições">
                                <span v-if="formatDate(oferta.datainicioinscricao,2)">{{ formatDate(oferta.datainicioinscricao,2) }}</span>
                                <span v-else class="ec-tabela__vazio">—</span>
                            </td>
                            <td data-label="Término das inscrições">
                                <span v-if="formatDate(oferta.dataterminoinscricao,2)">{{ formatDate(oferta.dataterminoinscricao,2) }}</span>
                                <span v-else class="ec-tabela__vazio">—</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li v-for="(aba, indice) in abas" :key="aba.id" class="nav-item">
                <a class="nav-link" :class="{ active: indice === 0 }" :id="aba.id + '-tab'" data-toggle="tab" :href="'#' + aba.id" role="tab" :aria-controls="aba.id" :aria-selected="indice === 0 ? 'true' : 'false'">{{ aba.rotulo }}</a>
            </li>
        </ul>
        <div class="tab-content pt-3" id="myTabContent">
            <div v-for="(aba, indice) in abas" :key="aba.id" class="tab-pane fade" :class="{ 'show active': indice === 0 }" :id="aba.id" role="tabpanel" :aria-labelledby="aba.id + '-tab'">
                <div class="table-responsive">
                    <table v-ec-datatable class="table table-sm table-hover ec-tabela mb-0">
                        <thead class="ec-thead">
                            <tr>
                                <th class="text-left">Inscrito</th>
                                <th>Webhook</th>
                                <th>Requisição ERP</th>
                                <th>Sincronização</th>
                                <th>Recebido em</th>
                                <th>Status da requisição</th>
                                <th>Status da inscrição</th>
                                <th>Origem</th>
                                <th class="text-right ec-tabela__col-acoes"><span class="sr-only">Ações</span></th>
                            </tr>
                        </thead>
                        <tbody v-if="existeDados(aba.tipo)">
                            <template v-for="aluno_captado in captados_webhook">
                                <tr v-if="aluno_captado.tipoeventoaviso==aba.tipo" :key="aluno_captado.id">
                                    <td class="text-left" data-label="Inscrito">
                                        <span class="ec-tabela__principal">
                                            <template v-if="aluno_captado.nomeinscrito">{{ aluno_captado.nomeinscrito }}</template>
                                            <span v-else class="ec-tabela__vazio">—</span>
                                        </span>
                                        <small class="ec-tabela__secundario">Contato CRM {{ contatoCrm(aluno_captado) || '—' }}</small>
                                    </td>
                                    <td data-label="Webhook">
                                        <span class="ec-tabela__principal">{{ aluno_captado.id }}</span>
                                    </td>
                                    <td data-label="Requisição ERP">
                                        <span v-if="aluno_captado.requisicao_id">{{ aluno_captado.requisicao_id }}</span>
                                        <span v-else class="ec-tabela__vazio">—</span>
                                    </td>
                                    <td data-label="Sincronização">
                                        <span v-if="aluno_captado.processado == 1" class="ec-status ec-status--sucesso">Sincronizado</span>
                                        <span v-else class="ec-status ec-status--aviso">Pendente</span>
                                    </td>
                                    <td data-label="Recebido em">{{ formatDate(aluno_captado.created_at,2) }}</td>
                                    <td class="oferta-col-status" data-label="Status da requisição">
                                        <span v-if="varianteStatusRequisicao(aluno_captado)" class="ec-status" :class="'ec-status--' + varianteStatusRequisicao(aluno_captado)">{{ aluno_captado.status }}</span>
                                        <span v-else class="ec-tabela__vazio">—</span>
                                    </td>
                                    <td data-label="Status da inscrição">
                                        <span v-if="varianteStatusInscricao(aluno_captado)" class="ec-status" :class="'ec-status--' + varianteStatusInscricao(aluno_captado)">{{ textoStatus(aluno_captado.status_inscricao) }}</span>
                                        <span v-else class="ec-tabela__vazio">—</span>
                                    </td>
                                    <td data-label="Origem">
                                        <span v-if="aluno_captado.origem_inclusao" class="ec-status ec-status--rotulo ec-status--neutro">{{ aluno_captado.origem_inclusao }}</span>
                                        <span v-else class="ec-tabela__vazio">—</span>
                                    </td>
                                    <td class="ec-tabela__col-acoes" data-label="Ações">
                                        <div class="ec-acoes">
                                            <a :href="'/Access/Unity/Unitie/'+oferta.unity_id+'/captacao/wh/'+aluno_captado.id" class="btn btn-sm ec-acao ec-acao--destaque" v-b-tooltip.hover title="Visualizar webhook" aria-label="Visualizar webhook"><b-icon icon="eye-fill"></b-icon></a>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="9" class="ec-tabela__estado">
                                    <b-icon icon="inbox" font-scale="2"></b-icon>
                                    <p>Nenhum webhook de {{ aba.rotulo }} recebido para esta oferta.</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['captacao','oferta'],
    data(){
        return{
            captados_webhook:[],
            // abas por tipo de webhook (tipoeventoaviso): c = inscrição confirmada, a = contrato aceito, m = matriculado
            abas:[
                { id:'home', rotulo:'Inscrição Confirmada', tipo:'c' },
                { id:'profile', rotulo:'Contrato Aceito', tipo:'a' },
                { id:'contact', rotulo:'Matriculado', tipo:'m' },
            ]
        }
    },
    methods:{
        contatoCrm(aluno_captado){
            return (aluno_captado.request_body ? JSON.parse(aluno_captado.request_body).contato.id : '')
        },
        // mesmas regras dos antigos alertas da coluna "Status" (requisição ERP)
        varianteStatusRequisicao(aluno_captado){
            if(aluno_captado.status=='success' && aluno_captado.requisicao_id>0) return 'sucesso'
            if(aluno_captado.requisicao_id>0) return 'erro'
            if(aluno_captado.processado==1 && aluno_captado.status!='success') return 'erro'
            return null
        },
        // mesmas regras dos antigos alertas da coluna "Status" (inscrição)
        varianteStatusInscricao(aluno_captado){
            if(aluno_captado.processado == 1 && aluno_captado.status_inscricao=='success' && aluno_captado.requisicao_id>0) return 'sucesso'
            if(aluno_captado.processado == 1 && aluno_captado.status_inscricao=='error' && aluno_captado.requisicao_id>0) return 'erro'
            if(aluno_captado.processado==1 && aluno_captado.status_inscricao=='pending') return 'info'
            return null
        },
        textoStatus(status){
            return { success:'Sucesso', error:'Erro', pending:'Pendente' }[status] || status
        },
        existeDados(tipoeventoaviso){
            for(let i = 0;i<this.captados_webhook.length;i++){
                if(this.captados_webhook[i].tipoeventoaviso==tipoeventoaviso){
                    return true
                }
            }
            return false
        },
        converteJsonObjeto(dados){
            
            //var x = JSON.stringify(dados.substring(1,dados.length-1),null,'\t');
            var a = JSON.parse(dados)
            console.log('a',a)
            return a
        },
        formatDate(date,idioma) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            if(idioma==1){
                let dt = [year, month, day].join('-');
                if(dt=='1969-12-31'){
                    return null
                }else{
                    return dt;
                }
            }else if(idioma==2){
                let dt = [day, month, year].join('/');
                if(dt=='31/12/1969'){
                    return null
                }else{
                    return dt;
                }
            }else{
                let dt = [year, month, day].join('-');
                if(dt=='1969-12-31'){
                    return null
                }else{
                    return dt;
                }
            }
        },
    },
    created(){
        console.log(this.captacao.data);
        this.captados_webhook = this.captacao;
    }
}
</script>

<style scoped>
    /* status com texto livre (mensagens do ERP) pode quebrar linha */
    .ec-tabela td.oferta-col-status {
        white-space: normal;
        min-width: 7rem;
        max-width: 16rem;
    }
</style>
